export { default } from './AlertInfo';



// WEBPACK FOOTER //
// ./src/design-system/molecules/AlertInfo/index.jsx